'use strict';

import { Factory } from 'rosie';

Factory.define('Id')
    // cast the ID to a string
    .sequence('id', [], (autoIncrementedId) => `${autoIncrementedId}`);



// WEBPACK FOOTER //
// ./factories/lib/id.js